(function() {
    'use strict';
    /**
     Enhances fake number counter for waiting pages. This code is a modification of this library: https://github.com/inorganik/countUp.js
     @param {Object} target DOM Object
     @param {Number} startValue Number
     @param {Number} endValue Number
     @param {Number} decimalDigits Number
     @param {Number} counterDuration Number
     @return {Object} Returns a counter object.
     */
    Odigeo.UIElements.enhanceCounter = function(target, startValue, endValue, decimalDigits, counterDuration) {
        var $target = (target instanceof $) ? target : $(target);
        var startVal = Number(startValue);
        var endVal = Number(endValue);
        var decimals = Math.max(0, decimalDigits || 0);
        var dec = Math.pow(10, decimals);
        var duration = counterDuration * 1000 || 2000;
        var startTime = null;
        var timestamp = null;
        var remaining = null;
        var frameVal = startVal;
        var rAF = null;
        var count;
        var start;
        var stop;
        var reset;
        var resume;
        var addCommas;
        var ease = Odigeo.Utils.Easing.randomEquation();
        var options = {
            useEasing: false,
        };

        if (!target || !($target instanceof $)) {
            return $target;
        }
        if ($target.attr('data-skip-enhance') === 'true') {
            return $target;
        }

        options = Odigeo._.extend(options, $target.data());

        $target.attr({'data-skip-enhance': true}).attr({'data-counter': true});

        if (options.duration) {
            duration = options.duration * 1000;
        }

        count = function(ts) {
            if (startTime === null) {
                startTime = ts;
            }

            timestamp = ts;
            var progress = timestamp - startTime;

            // to ease or not to ease
            if (options.useEasing) {
                frameVal = ease(progress, startVal, endVal - startVal, duration);
            } else {
                frameVal = startVal + (endVal - startVal) * (progress / duration);
            }

            // decimal
            frameVal = Math.round(frameVal * dec) / dec;

            frameVal = (frameVal > endVal) ? endVal : frameVal;

            // format and print value
            $target.html(addCommas(frameVal.toFixed(decimals)));

            // whether to continue
            if (progress < duration) {
                rAF = requestAnimationFrame(count);
            }
        };

        start = function() {
            // make sure values are valid
            if (!isNaN(endVal) && !isNaN(startVal)) {
                reset();
                rAF = requestAnimationFrame(count);
            }
            return false;
        };

        stop = function() {
            cancelAnimationFrame(rAF);
        };

        reset = function() {
            cancelAnimationFrame(rAF);
            $target.html(addCommas(startVal.toFixed(decimals)));
            startTime = null;
            timestamp = null;
        };

        resume = function() {
            startTime = null;
            duration = remaining;
            startVal = frameVal;
            requestAnimationFrame(count);
        };

        addCommas = function(nStr) {
            nStr += '';
            var x;
            var x1;
            var x2;
            var rgx;
            x = nStr.split('.');
            x1 = x[0];
            x2 = x.length > 1 ? '.' + x[1] : '';
            rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + Odigeo.Utils.Currency.thousandSeparator + '$2');
            }
            return x1 + x2;
        };

        $target
            .on('startCount', start)
            .on('stopCount', stop)
            .on('restartCount', reset)
            .on('resumeCount', resume);

        $target.rAF = rAF;

        return $target;
    };
}());
